import React from 'react';
import { PortfolioInfo } from 'communication/types/ContactSupportRequest';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import DetailPanel from 'widgets/supportVisualisation/Content/DetailPanel';
import { Tab } from '@instinet-analytics/semantic-ui-components';
import { WidgetPanelGrid } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanelGrid';
import Order from 'communication/types/order/Order';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import State from 'store/State';

export function PortfolioPanel(props: {
    portfolio: PortfolioInfo;
    width: number;
    height: number;
    state: State;
}) {
    const { height, width, portfolio } = props;

    const renderJson = () => <JsonPanel data={portfolio} />;
    const jsonPane = {
        menuItem: 'Json',
        render: renderJson,
    };

    const renderOrders = () => (
        <WidgetPanelGrid<Order>
            key="ordersGrid"
            data={portfolio?.first100Orders ?? []}
            getRowDataId={(d) => d.idx.toString()}
            csvFileName={`selected-orders`}
        />
    );
    const ordersPane = {
        menuItem: 'First 100 Orders',
        render: renderOrders,
    };

    const renderP = () => (
        <WidgetPanelGrid<PortfolioPosition>
            key="selectedPositionsGrid"
            data={portfolio?.first100FilteredOrders ?? []}
            getRowDataId={(d) => `${d.symbol}-${d.side}`}
            csvFileName={`selected-positions`}
        />
    );
    const positionsPane = {
        menuItem: 'First 100 Positions',
        render: renderP,
    };

    const panes = [jsonPane, ordersPane, positionsPane];

    return (
        <DetailPanel className="SelectionPanel" height={height} width={width}>
            <Tab
                className="widget-panel-tab"
                panes={panes}
                menu={{ secondary: true, pointing: true, inverted: true }}
            />
        </DetailPanel>
    );
}
